var map = {
	"./1inch.svg": "2a93",
	"./aave.svg": "4c9d",
	"./aggregated.svg": "d48c",
	"./binance.svg": "11b1",
	"./binancefutures.svg": "dab4",
	"./bitfinex.svg": "8766",
	"./bitmex.svg": "284e",
	"./bittrex.svg": "5da4",
	"./bnb.svg": "50aa",
	"./bybit.svg": "f904",
	"./coinbasepro.png": "bcb5",
	"./compound.svg": "a043",
	"./curve.svg": "0a80",
	"./ftx.svg": "d691",
	"./gateio.svg": "702d",
	"./gemini.svg": "7715",
	"./hitbtc.svg": "f4f6",
	"./huobi.svg": "bb03",
	"./huobifutures.svg": "1e59",
	"./kraken.svg": "e127",
	"./kucoin.svg": "e3f5",
	"./liquid.svg": "9915",
	"./okex.svg": "d1c9",
	"./optimism.svg": "b001",
	"./otcmarket.svg": "5246",
	"./pancakeswap.svg": "666e",
	"./polygon.svg": "8151",
	"./singlebroker.svg": "689c",
	"./singlebroker_dark.svg": "8ea5",
	"./sushiswap.svg": "d0b2",
	"./uniswap.svg": "8719"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c18b";